import { User } from "@/types/users"
import { datadogRum } from "@datadog/browser-rum"

export function setDatadogUser(user: User) {
  datadogRum.setUser({
    id: user.id,
    email: "email" in user ? user.email : undefined,
    wallet_address: "wallet_address" in user ? user.wallet_address : undefined,
    authorName: user.authorName,
  })
}
